import { useBMTheme } from '../../../theme';
export const getDividerStyle = (props) => {
    const { length, orientation, type, alignment } = props;
    const { BMComponents } = useBMTheme();
    let style = {};
    switch (type) {
        case 'SUBTLE':
            style = {
                ...style,
                backgroundColor: BMComponents.BMStyleLineBordercolorSubtle,
            };
            break;
        default:
        case 'BOLD':
            style = {
                ...style,
                backgroundColor: BMComponents.BMStyleLineBordercolorBold,
            };
            break;
    }
    switch (orientation) {
        case 'VERTICAL':
            style = {
                ...style,
                width: 1,
                height: length === 'STRETCH' ? '100%' : length,
            };
            break;
        default:
        case 'HORIZONTAL':
            style = {
                ...style,
                height: 1,
                width: length === 'STRETCH' ? '100%' : length,
            };
            break;
    }
    switch (alignment) {
        case 'RIGHT':
            style = {
                ...style,
                alignSelf: 'flex-end',
            };
            break;
        case 'CENTER':
            style = {
                ...style,
                alignSelf: 'center',
            };
            break;
        default:
        case 'LEFT':
            style = {
                ...style,
                alignSelf: 'flex-start',
            };
            break;
    }
    return style;
};
